// Estate configuration - fetches from public/manifest.json
let cachedEstateName = null;

export const getEstateName = async () => {
  if (cachedEstateName) {
    return cachedEstateName;
  }
  
  try {
    const response = await fetch("/manifest.json");
    const manifest = await response.json();
    const name = manifest.short_name || "estate";
    cachedEstateName = name.charAt(0).toUpperCase() + name.slice(1);
    return cachedEstateName;
  } catch (error) {
    console.error("Failed to load manifest.json:", error);
    return "Estate"; // Fallback name
  }
};

export const getEstateNameSync = () => {
  return cachedEstateName || "Estate";
};

